import { Component, Input, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { UtilsService } from '../../../Services/utils.service';
import { GuideStep } from '../../../Interfaces/interfaces';
import { FormsModule } from '@angular/forms';
import { GameWalletPanelComponent } from '../../../games/shared/game-wallet-panel/game-wallet-panel.component';
import { gameLobbyUrl } from '../../../games/shared/game-account/game-account.config';

interface Card {
  backgroundColor: string;
  ribbonGradient: string;
  buttonGradient: string;
  title: string;
  description: string;
  buttonText: string;
  maxWinText: string;
  upToText: string;
  chanceText: string;
  cardImage: string;
  iconImage: string;
}

@Component({
  selector: 'app-sectrech-card-list',
  standalone: true,
  imports: [CommonModule, FormsModule, GameWalletPanelComponent],
  templateUrl: './sectrech-card-list.component.html',
  styleUrls: ['./sectrech-card-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectrechCardListComponent implements OnInit {
  // activeTab: ActiveTabType = 'All';
  showModal = false;
  selectedGame: any;
  score = '';
  accountType = '';
  selectedPaymentMethod: 'wallet' | 'withdraw' = 'wallet';
  startDate: string | null = null;
  endDate: string | null = null;
  viewMode: 'grid' | 'table' = 'grid';
  // plusIcon = faPlus;
  //infoIcon = faCircleInfo;
  showDateFilter: boolean = false;
  dropdownOpen: boolean = false;
  searchTerm: string = '';
  selectedPriceFilter: string = 'all';
  priceFilters: string[] = ['all', '5', '10', '15', '20', '25', '30'];
  scratchBalance: number = 0;
  @ViewChild('walletPanel') walletPanel?: GameWalletPanelComponent;
  @Input() isHomePage: boolean = true;
  @Input() isDashBoard: boolean = false;
  constructor(
    private router: Router,
    private _route: ActivatedRoute,
    private utils: UtilsService,
    private cdr: ChangeDetectorRef,
  ) { }
  isLandingPage: boolean = true;
  isDashboardPage: boolean = true;
  isScratchCardPage: boolean = true;

  get customerId(): number {
    return Number(localStorage.getItem('customerId')) || 0;
  }

  ngOnInit() {
    this.scrollToTopSmooth();
    this.isLandingPage = this.router.url === '/';
    this.isDashboardPage = this.router.url === '/dashboard/home';
    this.isScratchCardPage = this.router.url === '/dashboard/scratch';

    // this.isDashboardPage = this.router.url.startsWith('/dashboard');

    if (this.isDashboardPage) {
      this.scratchCards = this.scratchCards.slice(0, 3);
    } else if (this.isLandingPage) {
      this.scratchCards = this.scratchCards.slice(0, 3);
    } else {
      this.scratchCards = this.scratchCards;
    }
  }

  get token() {
    return this.utils.getItem('token');
  }
  goToBuyNow(cardData: any) {
    this.cdr.markForCheck();
    this.cdr.detectChanges();
    if (this.token && this.token != null) {
      const encodedData = encodeURIComponent(JSON.stringify(cardData));
      this.router.navigate(['/dashboard/buy-now', encodedData]);
    } else {
      this.router.navigate(['/login'], {
        queryParams: { redirectUrl: '/dashboard/scratch' },
      });
    }

    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }

  get isToken(): boolean {
    return !!localStorage.getItem('token'); // returns true if token exists, false otherwise
  }

  onStartDateChange(date: string) {
    if (this.endDate && new Date(this.endDate) < new Date(date)) {
      this.endDate = null;
    }
  }
  resetDates() {
    this.startDate = null;
    this.endDate = null;
    // this.GetAllGames(true);
  }

  onGameBalance(balance: number): void {
    this.scratchBalance = balance;
    this.cdr.markForCheck();
  }

  openWalletDeposit(): void {
    this.walletPanel?.openDeposit();
  }

  setPriceFilter(price: string): void {
    this.selectedPriceFilter = price;
    this.cdr.markForCheck();
  }

  clearFilters(): void {
    this.searchTerm = '';
    this.selectedPriceFilter = 'all';
    this.cdr.markForCheck();
  }

  get filteredScratchCards() {
    let list = this.scratchCards;

    if (this.selectedPriceFilter && this.selectedPriceFilter !== 'all') {
      const price = Number(this.selectedPriceFilter);
      list = list.filter(card => card.ticketprice === price);
    }

    if (!this.searchTerm) return list;

    const term = this.searchTerm.toLowerCase().trim();
    return list.filter(card =>
      card.title.toLowerCase().includes(term) ||
      card.ticketprice.toString().includes(term) ||
      card.winning.toLowerCase().includes(term)
    );
  }

  get unusedFilteredScratchCards() {
    if (!this.searchTerm) return this.scratchCards;

    return this.scratchCards.filter(card =>
      card.title.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
      card.ticketprice.toString().includes(this.searchTerm)
    );
  }

  goBack() {
    this.router.navigateByUrl(gameLobbyUrl('SCRATCH'));
  }

  trackByTitle(index: number, card: any): string {
    return card.title;
  }

  showGuide() {
    const steps: GuideStep[] = [
      {
        imageUrl: '/scrachhow.png',

        imageUrlLg: '/scrachhow.png',
      },
    ];

    this.utils.open(steps, 0, {
      title: 'Scratch Card Guide',
    });
  }

  cards = [
    {
      ticketprice: 5,
      backgroundColor: '#062b35',
      ribbonGradient: 'from-[#0c3b4a] to-[#12485c]',
      buttonGradient: 'from-[#70e1f5] to-[#536976]',
      title: 'Scratch and Win',
      mainTitle: 'Exciting Scratch Cards',
      description:
        'Get ready to uncover incredible prizes! Our scratch card section is the perfect place to test your luck and see if fortune is on your side.',
      buttonText: 'Buy Now!',
      maxWinText: '$200',
      upToText: 'Up to',
      chanceText: 'Chance to Win',
      cardImage: '/scratchcard/scratch1.png',
      iconImage: '/scratchcard/scratch1.png',
    },
    {
      ticketprice: 10,
      backgroundColor: '#231438',
      ribbonGradient: 'from-[#3A1F5C] to-[#5A3C88]',
      buttonGradient: 'from-[#70e1f5] to-[#536976]',
      title: 'Daily Jackpot',
      mainTitle: 'Daily Jackpot Fun',
      description:
        'Try your luck every day! Scratch your way to amazing prizes and see if you are the lucky winner.',
      buttonText: 'Buy Now!',
      maxWinText: '$500',
      upToText: 'Up to',
      chanceText: 'Chance to Win',
      cardImage: '/scratchcard/scratch2.png',
      iconImage: '/scratchcard/scratch2.png',
    },
    {
      ticketprice: 15,
      backgroundColor: '#315994',
      ribbonGradient: 'from-[#1F3B66] to-[#223d72]',
      buttonGradient: 'from-[#70e1f5] to-[#536976]',
      title: 'Mega Prize',
      mainTitle: 'Mega Rewards',
      description:
        'Step into the world of mega prizes! Every scratch could bring you closer to the ultimate reward.',
      buttonText: 'Buy Now!',
      maxWinText: '$1000',
      upToText: 'Up to',
      chanceText: 'Chance to Win',
      cardImage: '/scratchcard/scratch3.png',
      iconImage: '/scratchcard/scratch3.png',
    },
    // Add more cards as needed
  ];

  card = {
    backgroundColor: '#062b35', // Card background color
    ribbonGradient: 'from-[#0c3b4a] to-[#12485c]', // Ribbon gradient
    buttonGradient: 'from-[#70e1f5] to-[#536976]', // Button gradient
    title: 'Scratch and Win',
    description:
      'Get ready to uncover incredible prizes! Our scratch card section is the perfect place to test your luck and see if fortune is on your side.',
    buttonText: 'Buy Now!',
    maxWinText: '$200',
    upToText: 'Up to',
    chanceText: 'Chance to Win',
    cardImage: '/scratchcard/scratch1.png',
    iconImage: '/scratchcard/scratch1.png',
  };

  scratchCards = [
    {
      ticketprice: 5,
      title: 'Diamond Rush',
      icon: '/cmax-assets/scratchcard/daimond.png',
      bgImage: '/scratch-neww.png',
      winning: '$200',
      treasure: '/win-box.png',
      buttonText: 'Buy Now!',
    },
    {
      ticketprice: 10,
      title: 'Gold Mania',
      icon: '/cmax-assets/scratchcard/fire.png',
      bgImage: '/scratch-neww.png',
      winning: '$300',
      treasure: '/win-box.png',
      buttonText: 'Buy Now!',
    },
    {
      ticketprice: 15,
      title: 'Treasure Hunt',
      icon: '/cmax-assets/scratchcard/crown.png',
      bgImage: '/scratch-neww.png',
      winning: '$400',
      treasure: '/win-box.png',
      buttonText: 'Buy Now!',
    },
    {
      ticketprice: 20,
      title: 'Diamond Rush',
      icon: '/cmax-assets/scratchcard/daimond.png',
      bgImage: '/scratch-neww.png',
      winning: '$500',
      treasure: '/win-box.png',
      buttonText: 'Buy Now!',
    },
    {
      ticketprice: 25,
      title: 'Gold Mania',
      icon: '/cmax-assets/scratchcard/fire.png',
      bgImage: '/scratch-neww.png',
      winning: '$1000',
      treasure: '/win-box.png',
      buttonText: 'Buy Now!',
    },
    {
      ticketprice: 30,
      title: 'Treasure Hunt',
      icon: '/cmax-assets/scratchcard/crown.png',
      bgImage: '/scratch-neww.png',
      winning: '$2000',
      treasure: '/win-box.png',
      buttonText: 'Buy Now!',
    },
  ];

  redirectToSignUp() {
    const token = localStorage.getItem('token');
    if (token) {
      this.router.navigate(['/dashboard/home']);
    } else {
      this.router.navigate(['/login']);
    }
  }

  // Component.ts
  getRotation(index: number, length: number): number {
    // Adjust the spread angle as needed, e.g., -30° to +30°
    const maxAngle = 30;
    const startAngle = -maxAngle;
    const angleStep = (maxAngle * 2) / Math.max(length - 1, 1);
    return startAngle + angleStep * index;
  }

  private scrollToTopSmooth(): void {
    try {
      // Use smooth scrolling when supported
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (e) {
      // Fallback for older browsers/environments
      try {
        window.scrollTo(0, 0);
      } catch {
        // ignore
      }
    }
  }
}
